/** @jsxImportSource @emotion/react */

import useBreakpoint from "../../hooks/useBreakpoint";

type CopyRightType = {
  copyRightLabel: string;
}
const CopyRight = ({copyRightLabel}: CopyRightType) => {

  const {isMobile} = useBreakpoint();
  return (
    <div
      css={{
        position: "absolute",
        left: 0,
        bottom: isMobile ? 4: 0,
        padding: 8,
        color: "white",
        backgroundColor: "#8888",
      }}
    >
      {copyRightLabel}
    </div>
  );
};

export default CopyRight;
